module.exports = __webpack_public_path__ + "static/media/time-management2.5c3cf445.png";